<template>
  <div class="notification-container">
    <div class="notification-header">
      <div>
        <div class="title">通知</div>
        <div class="summary">{{ notifications.length ? '最新未读消息' : '暂无未读消息' }}</div>
      </div>
      <button class="text-btn" type="button" @click="openDetail">全部</button>
    </div>

    <div class="notification-list" v-loading="listLoading">
      <div v-if="!listLoading && notifications.length === 0" class="empty-state">
        <i class="el-icon-bell"></i>
        <span>没有新的未读通知</span>
      </div>

      <div
        class="notification-item"
        v-for="(item, index) in notifications"
        :key="item.id || index"
        @click="handleAction(item)"
      >
        <div
          class="notification-icon"
          :style="{ background: getAvatarBg(index) }"
        >
          <img
            :src="getAvatarSrc(index)"
            alt="icon"
            class="icon-img"
          >
        </div>
        <div class="content">
          <div class="content-header">
            <div class="message-title">{{ item.messageName || '通知消息' }}</div>
            <div class="time">{{ formatTime(item.createTime) }}</div>
          </div>
          <div class="subtitle">{{ item.messageInfo }}</div>
          <div class="action-row">
            <span class="status" v-if="item.messageStatus === 1">未读</span>
            <button
              class="link-btn"
              type="button"
              v-if="item.messageStatus === 1"
              @click.stop="markAsRead(item)"
            >
              已读
            </button>
            <button
              class="link-btn primary"
              type="button"
              v-if="item.sourceId"
              @click.stop="handleAction(item)"
            >
              查看
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="view-all" @click="openDetail">
      查看所有通知
    </div>
  </div>
</template>

<script>
import {
  getUserMessageNotificationUptodateList,
  markMessageAsRead
} from "@/api/messageNotification";

// 图标配置（只存路径和背景色，和之前一致）
const typeStyleMap = [
  { 
    icon: require('../../../home/assets/imgs/DIV-1.png'),
    iconBg: '#E8F4FF'
  },
  { 
    icon: require('../../../home/assets/imgs/DIV-2.png'),
    iconBg: '#FFFBEB'
  },
  { 
    icon: require('../../../home/assets/imgs/DIV-3.png'),
    iconBg: '#FFEEF5'
  },
  { 
    icon: require('../../../home/assets/imgs/DIV-4.png'),
    iconBg: '#E8FAF5'
  },
  { 
    icon: require('../../../home/assets/imgs/DIV-5.png'),
    iconBg: '#E8F4FF'
  }
];

export default {
  name: "Message",
  data() {
    return {
      listQuery: {},
      notifications: [],
      listLoading: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      getUserMessageNotificationUptodateList(this.listQuery)
        .then(response => {
          this.listLoading = false;
          this.notifications = response.data || [];
        })
        .catch(() => {
          this.listLoading = false;
          this.notifications = [];
        });
    },

    openDetail() {
      this.$router.push({ path: '/messageDetail' });
    },

    markAsRead(item) {
      if (!item || !item.id || item.messageStatus !== 1) {
        return;
      }
      markMessageAsRead({ id: item.id }).then(() => {
        this.notifications = this.notifications.filter(message => message.id !== item.id);
        this.$emit("notice-change");
        this.$message.success("已标记为已读");
      }).catch(() => {
        this.$message.error("标记失败，请稍后重试");
      });
    },

    handleAction(item) {
      if (!item) {
        return;
      }
      const go = () => {
        if (Number(item.sourceType) === 1 && item.sourceId) {
          this.$router.push({
            name: "mySubmittedDetail",
            query: {
              id: item.sourceId,
              fromTab: "myApproval",
              allowApprove: 1,
              allowResubmit: 1
            }
          });
          return;
        }
        this.openDetail();
      };

      if (item.messageStatus === 1 && item.id) {
        markMessageAsRead({ id: item.id }).then(() => {
          this.$emit("notice-change");
          go();
        }).catch(go);
        return;
      }
      go();
    },

    // 获取背景色（循环逻辑不变）
    getAvatarBg(index) {
      const styleIndex = index % typeStyleMap.length;
      return typeStyleMap[styleIndex].iconBg;
    },

    // 获取图标路径（循环逻辑不变）
    getAvatarSrc(index) {
      const styleIndex = index % typeStyleMap.length;
      return typeStyleMap[styleIndex].icon;
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      return `${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-container {
  display: flex;
  flex-direction: column;
  width: 380px;
  min-height: 180px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;

  .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px 18px 12px;
    width: 100%;
    border-bottom: 1px solid #eef2f7;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      line-height: 24px;
      font-weight: 600;
      color: #111827;
    }

    .summary {
      margin-top: 2px;
      font-size: 12px;
      color: #8a94a6;
    }

    .text-btn {
      border: 0;
      background: transparent;
      color: #1677ff;
      cursor: pointer;
      font-size: 13px;
      line-height: 24px;
      padding: 0;
    }
  }

  .notification-list {
    min-height: 96px;
    max-height: 360px;
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;

    .empty-state {
      height: 128px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #9ca3af;
      font-size: 13px;

      i {
        font-size: 24px;
        color: #cbd5e1;
      }
    }

    .notification-item {
      display: flex;
      padding: 14px 18px;
      align-items: flex-start;
      width: 100%;
      box-sizing: border-box;
      cursor: pointer;
      transition: background-color 0.18s ease;
      border-bottom: 1px solid #f3f4f6;

      &:hover {
        background: #f8fbff;
      }

      &:last-child {
        border-bottom: 0;
      }

      .notification-icon {
        flex: 0 0 40px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
      }

      .icon-img {
        width: 18px;
        height: 18px;
        object-fit: contain;
      }

      .content {
        flex: 1;
        min-width: 0;

        .content-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 5px;
        }

        .message-title {
          font-size: 14px;
          font-weight: 600;
          color: #111827;
          white-space: normal;
          overflow: visible;
          text-overflow: clip;
          word-break: break-word;
        }

        .time {
          flex: 0 0 auto;
          font-size: 12px;
          color: #9ca3af;
        }

        .subtitle {
          font-size: 13px;
          line-height: 18px;
          color: #5f6b7a;
          display: block;
          overflow: visible;
          word-break: break-all;
        }

        .action-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 8px;
        }

        .status {
          font-size: 12px;
          border-radius: 999px;
          padding: 2px 8px;
          text-align: center;
          background: #fff1f2;
          color: #e11d48;
        }

        .link-btn {
          border: 0;
          background: transparent;
          color: #64748b;
          cursor: pointer;
          font-size: 12px;
          padding: 0;

          &.primary {
            color: #1677ff;
          }

          &:hover {
            color: #005bd3;
          }
        }
      }
    }
  }

  .view-all {
    width: calc(100% - 36px);
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #1677ff;
    font-size: 14px;
    cursor: pointer;
    border: 1px solid #d6e8ff;
    background: #f8fbff;
    border-radius: 6px;
    margin: 12px 18px 16px;
    box-sizing: border-box;

    &:hover {
      border-color: #1677ff;
      background: #eef6ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/message/index.vue